var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('alert',{staticClass:"mb-0",attrs:{"icon":"mdi-information-outline","icon-color":"#F44336","text-color":"#E31B0C","color":"#F443361A"},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }